import React from 'react';
import { Button, useToast } from '@crisellevaldez/speculo-ui';
import { Copy } from 'lucide-react';

export interface DnsRecordRow {
  type: string;
  host: string;
  value: string;
}

/** DNS records a client adds at their domain provider, with a Copy button for each host and value. */
export const DnsRecordsTable: React.FC<{ records: DnsRecordRow[] }> = ({ records }) => {
  const { showToast } = useToast();
  const copy = (text: string, label: string) => {
    navigator.clipboard.writeText(text);
    showToast({ message: `${label} copied to clipboard`, variant: 'success' });
  };

  return (
    <div className="overflow-x-auto rounded-lg border border-gray-200 dark:border-white/10">
      <table className="w-full text-sm">
        <thead className="bg-gray-50 dark:bg-white/5 text-left">
          <tr>
            <th className="px-3 py-2 font-semibold">Type</th>
            <th className="px-3 py-2 font-semibold">Host</th>
            <th className="px-3 py-2 font-semibold">Value</th>
          </tr>
        </thead>
        <tbody>
          {records.map((record) => (
            <tr key={record.host} className="border-t border-gray-200 dark:border-white/10">
              <td className="px-3 py-2 align-top">{record.type}</td>
              {(
                [
                  ['Host', record.host],
                  ['Value', record.value],
                ] as const
              ).map(([label, text]) => (
                <td key={label} className="px-3 py-2 align-top">
                  <div className="flex items-start gap-2">
                    <code className="break-all text-xs">{text}</code>
                    <Button
                      type="button"
                      variant="outline"
                      size="sm"
                      onClick={() => copy(text, label)}
                      aria-label={`Copy ${label}`}
                    >
                      <Copy className="w-3 h-3" />
                    </Button>
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
